import React from 'react'

import { withRouter } from 'react-router-dom'

import moment from 'moment';

import { Container, Label, Button, Icon } from 'semantic-ui-react';

import { Section, Properties } from 'components';
import { ModalOptions, ModalUploadFirmware } from 'modals';

import { EnumChannel } from 'enums';

import { BreadcrumbHelper, Typeof } from 'utils';
import { API } from 'services';

import './style.css';

class FirmwareScene extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      firmware: this.props.firmware,
      showEditModal: false,
      showDeleteModal: false
    };

    this.toggleEditModal = this.toggleEditModal.bind(this);
    this.handleEditModalClose = this.handleEditModalClose.bind(this);

    this.toggleDeleteModal = this.toggleDeleteModal.bind(this);
    this.handleDeleteModalClose = this.handleDeleteModalClose.bind(this);
  }

  componentWillMount() {
    this.updateBreadcrumb();
  }

  updateBreadcrumb() {
    BreadcrumbHelper.reset();
    BreadcrumbHelper.push('Accueil', '/');
    BreadcrumbHelper.push('Micrologiciels capteur', '/firmwares');
    BreadcrumbHelper.push(EnumChannel.name(this.props.firmware.channel), `/firmwares?channel=${this.props.firmware.channel}`);
    BreadcrumbHelper.push(this.props.firmware.version);
    BreadcrumbHelper.flush();
  }

  toggleEditModal() {
    this.setState({
      showEditModal: !this.state.showEditModal
    });
  }

  handleEditModalClose(firmware) {

    if(Typeof.object(firmware)) {

      this.setState({
        firmware: firmware
      });
    }

    this.toggleEditModal();
  }

  toggleDeleteModal() {

    //Show modal
    this.setState({
      showDeleteModal: !this.state.showDeleteModal
    });
  }

  handleDeleteModalClose(result, setProcessing) {

    if(result === ModalOptions.OPTION_YES) {

      setProcessing(result);

      API.delete(`/firmwares/${this.props.firmware.channel}/${this.props.firmware.version}`)
        .then(() => {

          //Go back to firmwares list
          this.props.history.push('/firmwares');
        });
    }

    //Hide modal
    this.toggleDeleteModal();
  }

  render() {

    let firmware = this.state.firmware;

    let informations = [
      {
        name: 'Version',
        value: <b>{firmware.version}</b>
      },
      {
        name: 'Canal',
        value: <Label color={EnumChannel.color(firmware.channel)}>{EnumChannel.name(firmware.channel)}</Label>
      },
      {
        name: "Version minimale de l'application",
        value: firmware.minimum_app_version
      },
      {
        name: 'Disponible',
        value: <Icon name={firmware.available ? "checkmark" : "times"} color={firmware.available ? "green" : "red"} />
      },
      {
        name: 'Date de téléversement',
        value: moment(firmware.date_create).format('[Le] DD/MM/YYYY [à] HH:mm:ss')
      }
    ];

    return (
      <React.Fragment>

        {/* Informations */}
        <Container>

          <Section title="Informations" actions={[
            <Button icon="edit" circular onClick={this.toggleEditModal} key={0} />,
            <Button icon="trash" circular color="red" onClick={this.toggleDeleteModal} key={1} />
          ]}>
            <Properties properties={informations} />
          </Section>

        </Container>

        {/* Firmware edit modal */}
        {this.state.showEditModal &&
          <ModalUploadFirmware firmware={firmware} onClose={this.handleEditModalClose} />
        }

        {/* Firmware delete warning modal */}
        {this.state.showDeleteModal &&
          <ModalOptions onClose={this.handleDeleteModalClose} icon="trash alternate" title="Suppression" message={<span>Vous êtes sur le point de supprimer ce micrologiciel.<br /><br />Voulez vous continuer ?</span>} options={ModalOptions.OPTIONS_YESCANCEL} />
        }

      </React.Fragment>
    );
  }
}

export default withRouter(FirmwareScene);
